import { toast } from "sonner";

const dateF = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric" });
const timeF = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" });

export const fmtDate = (d) => (d ? d.split("-").reverse().join("/") : "—");
export const fmtDay = (iso) => (iso ? dateF.format(new Date(iso)) : "—");
export const fmtTime = (iso) => (iso ? timeF.format(new Date(iso)) : "—");
export const fmtDateTime = (iso) => (iso ? `${fmtDay(iso)} – ${fmtTime(iso)}` : "—");

export const trackingLink = (code) => `${window.location.origin}/traccia/${code}`;

export async function copyText(text, message = "Copiato negli appunti") {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  toast.success(message);
}

export function waPhone(phone) {
  let digits = (phone || "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length >= 9 && digits.length <= 10 && digits.startsWith("3")) digits = `39${digits}`;
  return digits;
}
